// extracted by mini-css-extract-plugin
export default {"container":"Tokenomics_container__1-hHb","form":"Tokenomics_form__C2c2H"};